import React from 'react';

import NewFeature16Icon from '../../glyph/new-feature/16';

export default () => <NewFeature16Icon label="" />;
